import { FaSearch, FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { CiEdit } from "react-icons/ci";
import { MdOutlineDeleteOutline } from "react-icons/md";
import Swal from "sweetalert2";
import { deleteEmployee, getAllEmployee } from "../apis/employeeApi";

const Employee = () => {
  const [datas, setDatas] = useState([]);

  useEffect(() => {
    getAllEmployee()
      .then((res) => setDatas(res.data))
      .catch((err) => console.log(err));
  }, []);

  // Delete function
  const handleDelete = async (id, name) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `You won't be able to revert this! '${name}'`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      await deleteEmployee(id);
      Swal.fire({
        title: "Deleted!",
        text: `Employee '${name}' has been deleted.`,
        icon: "success",
      });
      setDatas(datas.filter((emp) => emp._id !== id));
    }
  };

  return (
    <div className="p-4">
      {/* Header */}
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-6 gap-4">
        <h1 className="text-2xl font-semibold">Employees</h1>
        <div className="flex gap-2 w-full md:w-auto">
          <div className="relative flex-1 md:flex-none">
            <input
              type="text"
              placeholder="Search..."
              className="w-full py-2 pl-3 pr-10 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-red-400"
            />
            <FaSearch className="absolute right-3 top-1/2 -translate-y-1/2 text-red-500" />
          </div>
          <Link to="/addEmployee">
            <button className="flex items-center gap-2 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition">
              <FaPlus /> Add Employee
            </button>
          </Link>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full border rounded-lg overflow-hidden">
          <thead className="bg-red-600 text-white">
            <tr>
              {["S.No", "Name", "Email", "Mobile", "Address", "Aadhaar", "License", "Actions"].map((heading) => (
                <th key={heading} className="px-4 py-2 text-left text-sm uppercase">
                  {heading}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {datas.length > 0 ? (
              datas.map((user, index) => (
                <tr key={user._id} className="hover:bg-gray-50">
                  <td className="px-4 py-2 text-sm">{index + 1}</td>
                  <td className="px-4 py-2 text-sm">{user.name}</td>
                  <td className="px-4 py-2 text-sm">{user.email}</td>
                  <td className="px-4 py-2 text-sm">{user.mobile}</td>
                  <td className="px-4 py-2 text-sm">{user.address}</td>
                  <td className="px-4 py-2">
                    <img src={user.aadhaar} alt="aadhaar" className="w-10 h-10 rounded-md object-cover" />
                  </td>
                  <td className="px-4 py-2">
                    <img src={user.driving} alt="license" className="w-10 h-10 rounded-md object-cover" />
                  </td>
                  <td className="px-4 py-2 flex gap-2">
                    <Link to="/adduser" state={{ user }}>
                      <CiEdit className="text-green-600 hover:text-green-800 cursor-pointer" size={25} />
                    </Link>
                    <MdOutlineDeleteOutline
                      onClick={() => handleDelete(user._id, user.name)}
                      className="text-red-600 hover:text-red-800 cursor-pointer"
                      size={25}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center py-4 text-gray-500">
                  No employees found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Employee;
